import type { FreshnessChip as FreshnessChipView } from "@/lib/analytics/freshness";

/** One freshness chip (CMP-11.09, ANL-E04-S09 AC3), with the failed-run sub-line when there is one. */
const FreshnessChip = ({ chip }: { chip: FreshnessChipView }) => (
  <span className="pz-freshness" data-freshness={chip.state}>
    <span className={chip.className}>{chip.label}</span>
    {chip.subLine ? <span className="pz-freshness__sub">{chip.subLine}</span> : null}
  </span>
);

export default FreshnessChip;
